import { bindActionCreators } from 'redux';
import { withExperiments } from '@wix/wix-experiments-react';
import {
  clearCustomerSession,
  displayModal,
  goToSettings,
  hideModal,
  init,
  setFirstTime,
  sideMenuDisplay,
} from '../../stateManagement/engine/actions/SessionActions';
import { cancelOrder } from '../../stateManagement/engine/actions/OrderActions';
import { goTo } from '../../stateManagement/engine/actions/HistoryActions';
import { connect } from 'react-redux';
import Main from './Main';

function mapStateToProps(state) {
  return {
    step: state.session.step,
    user: state.session.user,
    msid: state.session.msid,
    organization: state.session.organization,
    menu: state.session.menu,
    lowResMenuShown: state.session.lowResMenuShown,
    modals: state.session.modals,
    simplifiedMenu: state.session.simplifiedMenu,
    emptyState: state.session.emptyState,
    isFirstTime: state.session.isFirstTime,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return bindActionCreators(
    {
      initSession: ownProps.initSession || init,
      sideMenuDisplay,
      cancelOrder,
      hideModal,
      clearCustomerSession,
      goTo,
      displayModal,
      setFirstTime,
      goToSettings,
    },
    dispatch,
  );
}

export default withExperiments(connect(mapStateToProps, mapDispatchToProps)(Main));
